export default __webpack_public_path__ + "static/transparency-illustration-c9565b59d5d8cc79ab87470b33db05b3.png";